import { PermissionsError, NotFoundError, errorsFactory } from '../../../utils';

export const PermissionsCheckFail = errorsFactory('PermissionsCheckFail');

export const CUSTOM_ERRORS_LIST = [
    PermissionsError,
    NotFoundError,
    PermissionsCheckFail,
];
